import React from "react";
import {
  Box,
  IconButton,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerCloseButton,
  List,
  Divider,
  Button,
  Image,
  Flex,
  Link as ChakraLink,
  VStack,
} from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";
import { Link } from "react-router-dom";
import SidebarItem from "./SidebarItem"; // Adjust the path if needed
import Translate from "../LanguageTranslation/Translate"; // Adjust the path if needed
import { ReactComponent as DonateWhiteIcon } from "../../assets/icons/donate-white.svg";
import logo from "../../assets/images/logo1.png";
import MobileTopBar from "./MobileTopBar";
import MobileBottomNav from "./MobileBottomNav";
import HamburgerButton from "../common/HamburgerButton";
// import SettingsMenu from "../common/SettingsMenu";

const BaseScreenMenu = ({
  colorMode,
  isOpen,
  onOpen,
  onClose,
  navLinks,
  popoverLinks,
  isSidebarOpen,
  logoutAndClear,
}) => {
  return (
    <Box
      display={{ base: "block", md: "block", lg: "none" }}
      h="100vh"
      bg={colorMode === "dark" ? "gray.800" : "white"}
      color={colorMode === "dark" ? "gray.200" : "blackAlpha.700"}
      borderRight="1px"
      borderColor="blackAlpha.200"
      // p={1}
      pt="6px"
    >
       {/* <MobileTopBar onOpen={onOpen} /> */}
       {/* <IconButton
        icon={<HamburgerIcon />}
        aria-label="Open Menu"
        onClick={onOpen}
        size="sm"
        variant="outline"
      /> */}
      {/* <HamburgerButton onClick={onOpen}/> */}
      <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>
            <Link to="/home">
              <Image src={logo} height="23px" />
            </Link>
          </DrawerHeader>

          <DrawerBody pl={0} pr="32px">
            <List spacing={4}>
              {/* Navigation Links */}
              {navLinks.map((link, index) => (
                <SidebarItem
                  key={index}
                  icon={link.icon}
                  to={link.to}
                  label={link.text}
                  isOpen={isSidebarOpen}
                  ml={0}
                  onClick={link.onClick}
                />
              ))}

              {/* <Divider /> */}

              {/* Popover Links */}
              {/* <VStack align="left" spacing={1} mt={2}>
              {popoverLinks.map((link, index) => (
                <ChakraLink
                  as={Link}
                  key={index}
                  to={link.to}
                  p={1}
                  pl={4}
                  pr={4}
                  fontSize="sm"
                  fontWeight="normal"
                  w="100%"
                  _hover={{ bg: "blue.100", color: "blue.800" }}
                >
                  {link.text}
                </ChakraLink>
              ))}
              </VStack> */}
              <Flex align="center" justifyContent="center" mb={4}>
                <Button
                  leftIcon={<DonateWhiteIcon width="24px" height="24px" />}
                  as={Link}
                  to="/offset-your-carbon-footprint"
                  bg="#286328"
                  color="white"
                  size="sm"
                  _hover="none"
                  width="80%"
                >
                  <Translate text="Contribute" />
                </Button>
              </Flex>
              {/* <Divider /> */}
              <Flex align="center" justifyContent="center" mb={4}>
                {/* Logout Button */}
                <Button
                  bg="#901225"
                  color="white"
                  size="sm"
                  _hover="none"
                  width="80%"
                  onClick={logoutAndClear}
                >
                  Logout
                </Button>
                {/* <SettingsMenu onHamburgerClick={onOpen}/> */}
              </Flex>
            </List>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <MobileBottomNav />
    </Box>
  );
};

export default BaseScreenMenu;
